<!--
 * @Description: ED - 时间颗粒度统计图
 * @LastEditors: Ji Yinghao
 * @Date: 2019-05-05 13:42:39
 * @LastEditTime: 2019-11-05 14:51:47
 -->
<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="dialog = false">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>ED详情</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark flat @click="dialog = false">返回</v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-list three-line subheader>
          <v-subheader v-if="desserts.length > 0">
            <v-chip color="secondary" text-color="white">开始时间：{{ desserts[0].start_time | time }}</v-chip>
            <v-chip
              color="secondary"
              text-color="white"
            >停止时间：{{ desserts[desserts.length-1].start_time | time }}</v-chip>
            <v-chip
              color="red"
              text-color="white"
            >监测时长：{{ formatSeconds( this.desserts[this.desserts.length-1].start_time - this.desserts[0].start_time ) }}</v-chip>
            <v-chip color="red" text-color="white">平均硬度：{{ ave_strength }}g</v-chip>
            <v-chip color="red" text-color="white">最大硬度：{{ max_strength }}g</v-chip>
            <v-chip color="red" text-color="white">干预因素：{{ factors == ""?"无干预":factors }}</v-chip>
            <v-btn
              round
              color="primary"
              dark
              :loading="loader"
              :disabled="loader"
              @click="download(`${user_name}(${ time(desserts[0].start_time)  }+${ time(desserts[desserts.length-1].start_time) }).json` )"
            >
              <v-icon>cloud_download</v-icon>&nbsp; 下载JSON数据
            </v-btn>
            <a href id="download_"></a>
          </v-subheader>
        </v-list>
        <v-divider></v-divider>
        <v-list three-line subheader>
          <div xs12 md3 id="myChart_" :style="{width: '99.5%', height: '84vh'}"></div>
         <v-list three-line subheader id="kkk" >
          <v-subheader>
            <v-chip color="red" text-color="white"> 有效勃起次数： {{ b_num }}</v-chip>
            <v-chip color="secondary" text-color="white"> g≥ {{ erection.E }} (mins)： {{ formatSeconds(list_g[4]*5) }}</v-chip>
            <v-chip color="secondary" text-color="white"> {{ erection.D }}≤ g &lt; {{ erection.E }}(mins)： {{  formatSeconds(list_g[3]*5) }}</v-chip>
            <v-chip color="secondary" text-color="white"> {{ erection.C }}≤ g &lt; {{ erection.D }}(mins)： {{  formatSeconds(list_g[2]*5) }}</v-chip>
            <v-chip color="secondary" text-color="white"> {{ erection.B }}≥ g &lt; {{ erection.C }}(mins)： {{  formatSeconds(list_g[1]*5) }}</v-chip>
            <v-chip color="secondary" text-color="white"> g &lt; {{ erection.B }}(mins)： {{  formatSeconds(list_g[0]*5) }}</v-chip>
            <a href id="download_"></a>
          </v-subheader>
        </v-list>
          <div xs12 md3 id="myChart__" :style="{width: clientWidth_() > w? '49%': '99%', height: '90vh'}"></div>
          <div xs12 md3 id="myChart___" :style="{width: clientWidth_() > w? '49%': '99%', height: '85vh'}"></div>
        </v-list>
      </v-card>
    </v-dialog>
    <!-- loding... -->
    <div class="text-xs-center">
    <!-- <v-btn
      :disabled="dialog__"
      :loading="dialog__"
      class="white--text"
      color="purple darken-2"
      @click="dialog__ = true"
    >
      Start loading
    </v-btn> -->
    <v-dialog
      v-model="dialog__"
      hide-overlay
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          正在画图...
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
  </v-layout>
</template>


<script>
import $echarts from "echarts";
// import { setTimeout } from "timers";
// import { SSL_OP_TLS_BLOCK_PADDING_BUG } from 'constants';
export default {
  data() {
    return {
      loader: false,
      // loding...
      dialog__: false,
      // 弹出框
      dialog: false,
      // 面包屑
      headers: [
        {
          text: "时间颗粒度",
          align: "center",
          sortable: false,
          value: "name"
        },
        {
          text: "勃起力度( g )",
          value: "fat",
          align: "center",
          sortable: false
        }
      ],
      desserts: [], // 线数据列表
      desserts_:[], // 饼数据列表
      user_name: "", // 用户名
      ave_strength: 0, // 平均
      max_strength: 0, // 最大
      duration: 0, // 时长
      factors: "",
      // 统计数据
      statistics_data: {},
      // 区间数据
      erection: {
        A: 0,
        B: 90,
        C: 140,
        D: 190,
        E: 500,
        F: 550
      },
      // 区间统计
      list_g:[0,0,0,0,0],
      b_num:0,
      w: 714
    };
  },
 
  // 更新完成
  mounted: function() { this.clientWidth_(); },
  methods: {
     // 计算屏幕宽度
  clientWidth_(){
    return document.body.clientWidth;
  },
    // 时间格式
    time(dataStr) {
      var time = new Date(dataStr * 1000);
      function timeAdd0(str) {
        if (str < 10) {
          str = "0" + str;
        }
        return str;
      }
      var y = time.getFullYear();
      var m = time.getMonth() + 1;
      var d = time.getDate();
      var h = time.getHours();
      var mm = time.getMinutes();
      var s = time.getSeconds();
      return (
        y +
        "-" +
        timeAdd0(m) +
        "-" +
        timeAdd0(d) +
        " " +
        timeAdd0(h) +
        ":" +
        timeAdd0(mm) +
        ":" +
        timeAdd0(s)
      );
    },
    // 秒转换时分秒
    formatSeconds(value) {
        let time=value;
        let min=Math.floor(time%3600);
        return (Math.floor(time/3600)<10?`0${Math.floor(time/3600)}`:Math.floor(time/3600)) + ":" + ((Math.floor(min/60))<10?`0${Math.floor(min/60)}`:Math.floor(min/60)) + ":"+ (time%60<10?`0${time%60}`:time%60);
    },
    // 弹出全屏框
    dialogShow(data) {
      this.dialog__ = true;
      this.desserts_ = data.list;
      // 按时间线缺省补零
      let starting_time = data.list[0].start_time;
      let end_time = data.list[data.list.length-1].start_time;
      let list_ = {};
      data.list.forEach(element => {
        list_[`${element.start_time}`] = element.strength;
      });
      let list = [];
      for (let time = starting_time; time <= end_time; time+=5) {
        if( `${time}` in list_ ){
          list.push({
            start_time: time,
            strength: list_[`${ time }`]
          })
        }else{
          list.push({
            start_time: time,
            strength:0
          })
        }
      }
       this.desserts = list;

// let location = [
//   {
//     "sheng_name":"河南省",
//     "shi_list":[
//       {
//         "shi_name":"周口市",
//         "hospital_list":[
//           "周口市北大医院",
//           "周口市清华医院",
//           "周口市第三人民医院"
//         ]
//       }
//       ...
//     ]
//   },
//   {
//     "sheng_name":"广东省",
//     "shi_list":[
//       {
//         "shi_name":"深圳",
//         "hospital_list":[
//           "深圳北大医院",
//           "深圳清华医院",
//           "深圳第三人民医院"
//         ]
//       }
//       ...
//     ]
//   }
//   ...
// ]

// -------------------------------------------------

let boNum = 0; // 勃起次数
// let SNum = false; // 是否计数

if( list.length >= 36 ){
  let list_ = [];
  let list__ = [];
  // let list_all = [];
  let num = 0;
  let num_ = 0;
  for (let index = 0; index <= list.length-1; index++) {
    if( list[index].strength > 0 ){
      num++;
       if( index == list.length-1 &&  num !== 0 ){
        list_.push( num );
      }
    }else{
      if( num !== 0  ){
        list_.push( num );
        num = 0;
      }
    }
    if( list[index].strength == 0 ){
      num_++;
      if( index == list.length-1 && num !== 0  ){
        list_.push( num );
      }
    }else{
      if( num_ > 0 ){
        list__.push( num_ );
        num_ = 0;
      }
    }
  }
  for (let index = 0; index <= list_.length-1; index++) {
      if( list_[index] >= 36 ){
        if(list__[index-1] >= 120 ){
           boNum = boNum+1;
        }
      }
    }
}

this.b_num = boNum;
// -------------------------------------------------
      this.dialog = data.state;
      this.user_name = data.user_name;
      this.ave_strength = data.ave_strength;
      this.factors = data.factors;
      setTimeout(() => {
        this.drawLine();
        this.drawBar();
        this.drawBar_();
      }, 400);
    },
    // 整理图表数据
    chartData(key) {
      let list = [];
      if (key == "start_time") {
        this.desserts.forEach(item => {
          list.push(this.time(item[key]));
        });
      } else {
        this.desserts.forEach(item => {
          list.push(item[key]);
        });
        this.max_strength = Math.max(...list);
      }
      return list;
    },
    // 下载原始数据
    download(filename) {
      this.loader = true;
      setTimeout(() => {
        this.loader = false;
      }, 3000);
        this.$Dialog.getProductCheckResult_({
                text: "数据正在下载... 如果下载无响应，请更换Chrome和Firefox下载。",
                timeout: 3000,
                snackbar: true
            })

      let text = this.desserts;
      // text = JSON.stringify(this.desserts, null, "\t");
      // let timeList = [];
      // JSON.parse(text).forEach(item => {
      //   timeList.push(`${this.time(item.start_time)}`);
      //   timeList.push(`${item.strength}`);
      // });
      // console.log(JSON.stringify(timeList, null, "\t"));

      var pom = document.getElementById("download_");
      pom.setAttribute(
        "href",
        "data:json/plain;charset=utf-8," +
          encodeURIComponent(JSON.stringify(text, null, "\t"))
      );
      pom.setAttribute("download", filename);
      if (document.createEvent) {
        var event = document.createEvent("MouseEvents");
        event.initEvent("click", true, true);
        pom.dispatchEvent(event);
      } else {
        pom.click();
      }
    },
    // 饼状图
    drawBar_() {
      let myChart = $echarts.init(document.getElementById("myChart___"));
      myChart.setOption({
        title : {
        text: '时间区间统计图',
        subtext: this.clientWidth_() > this.w? '数据来源：海恩思(深圳)信息科技有限公司': '',
        x:'center',
        top: this.clientWidth_() > this.w? 0: 120,
    },
    toolbox: {
          feature: {
            dataZoom: {
              yAxisIndex: "none"
            },
            restore: {},
            saveAsImage: {},
            dataView: {
              default: "数据视图"
            }
          },
          right: this.clientWidth_() > this.w? 50: 5
        },
    color: ["#ff9649", "#d8bd28", "#3885e3", "#43af46", "#c23531"], //环形图每块的颜色
    tooltip : {
        trigger: 'item',
        formatter: "{a} <br/>{b} : {c} ({d}%)"
    },
    legend: {
        orient: 'vertical',
        left: this.clientWidth_() > this.w? 120: 5,
        data: [`未勃起[${ this.formatSeconds(this.list_g[0]*5) }]`,`无效勃起[${ this.formatSeconds(this.list_g[1]*5) }]`,`勃起不充分[${ this.formatSeconds(this.list_g[2]*5) }]`,`正常勃起[${ this.formatSeconds(this.list_g[3]*5) }]`,`超人[${ this.formatSeconds(this.list_g[4]*5) }]`]
    },
    series : [
        {
            name: '访问来源',
            type: 'pie',
            radius : '55%',
            center: ['50%', '50%'],
            data:[
                {value: this.list_g[0], name:`未勃起[${ this.formatSeconds(this.list_g[0]*5) }]`},
                {value: this.list_g[1], name:`无效勃起[${ this.formatSeconds(this.list_g[1]*5) }]`},
                {value: this.list_g[2], name:`勃起不充分[${ this.formatSeconds(this.list_g[2]*5) }]`},
                {value: this.list_g[3], name:`正常勃起[${ this.formatSeconds(this.list_g[3]*5) }]`},
                {value: this.list_g[4], name:`超人[${ this.formatSeconds(this.list_g[4]*5) }]`}
            ],
            itemStyle: {
                emphasis: {
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
            }
        }
    ]
      })
      this.dialog__ = false;
    },
    // 雷达图统计图
    drawBar() {
      let myChart = $echarts.init(document.getElementById("myChart__"));
      let max = this.desserts_.length <= 1 ? 2 : this.desserts_.length / 2;
      let list = [0, 0, 0, 0, 0];
      for (let index = 0; index < this.desserts_.length; index++) {
        let num = this.desserts_[index].strength;
        if (num < this.erection.B) {
          list[0]++;
        } else if (num >= this.erection.B && num < this.erection.C) {
          list[1]++;
        } else if (num >= this.erection.C && num < this.erection.D) {
          list[2]++;
        } else if (num >= this.erection.D && num < this.erection.E) {
          list[3]++;
        } else if (num >= this.erection.E) {
          list[4]++;
        }
      }
      this.list_g = list;
      myChart.setOption({
        title: {
          text: this.clientWidth_() > this.w? "力值区间统计": "",
          subtext:this.clientWidth_() > this.w? "数据来源：海恩思(深圳)信息科技有限公司": "" ,
          x: "center"
        },
        toolbox: {
          feature: {
            dataZoom: {
              yAxisIndex: "none"
            },
            restore: {},
            saveAsImage: {},
            dataView: {
              default: "数据视图"
            }
          },
          right: this.clientWidth_() > this.w? 50: 5,
        },
        legend: {
          data: ["力值区间统计"],
          left:5
        },
         grid: {
            left: 120,
            right: 50,
          },
        radar: {
          // shape: 'circle',
          splitNumber: 5,
          name: {
            textStyle: {
              fontSize: 14,
              borderColor: "#ddd",
              borderWidth: 1,
              borderRadius: 3,
              padding: [7, 10, 5, 10]
            },
            show: true,
            formatter: function(value) {
              return "【 " + value + " 】";
            }
          },
          indicator: [
            {
              name: `未勃起 / ${((list[0] / (max * 2)) * 100).toFixed(2)}%`,
              max: max,
              color: "#ff9649"
            },
            {
              name: `无效勃起 / ${((list[1] / (max * 2)) * 100).toFixed(2)}%`,
              max: max,
              color: "#d8bd28"
            },
            {
              name: `勃起不充分 / ${((list[2] / (max * 2)) * 100).toFixed(2)}%`,
              max: max,
              color: "#3885e3"
            },
            {
              name: `正常勃起 / ${((list[3] / (max * 2)) * 100).toFixed(2)}%`,
              max: max,
              color: "#43af46"
            },
            {
              name: `超人 / ${((list[4] / (max * 2)) * 100).toFixed(2)}%`,
              max: max,
              color: "#c23531"
            }
          ],
          triggerEvent: true,
          silent: true
        },
        tooltip: {
          show: true,
          trigger: "item"
        },
        series: [
          {
            name: "力值区间统计",
            type: "radar",
            // areaStyle: {normal: {}},
            data: [
              {
                value: list,
                name: "勃起数据区间统计"
              }
            ]
          }
        ]
      });
    },
    // 线柱统计图
    drawLine() {
      let myChart = $echarts.init(document.getElementById("myChart_"));
      myChart.setOption({
        title: {
          text: this.clientWidth_() > this.w? "时间颗粒度统计": "",
          subtext: this.clientWidth_() > this.w? "数据来源：海恩思(深圳)信息科技有限公司": "" ,
          x: "center",
          top: 0
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            animation: false
          }
        },
        legend: {
          data: ["折线图统计", "柱状图统计"],
          x: "left",
          left:  this.clientWidth_() > this.w? 120: 5
        },
        toolbox: {
          feature: {
            dataZoom: {
              yAxisIndex: "none"
            },
            restore: {},
            saveAsImage: {},
            dataView: {
              default: "数据视图"
            }
          },
          right: this.clientWidth_() > this.w? 50: 5
        },
        axisPointer: {
          link: { xAxisIndex: "all" }
        },
        dataZoom: [
          {
            show: true,
            realtime: true,
            start: 0,
            end: 100,
            xAxisIndex: [0, 1]
          },
          {
            type: "inside",
            realtime: true,
            start: 0,
            end: 100,
            xAxisIndex: [0, 1]
          }
        ],
        grid: [
          {
            left: this.clientWidth_() > this.w? 120: 5,
            right: this.clientWidth_() > this.w? 50: 5,
            top:  this.clientWidth_() > this.w? "10%": "0%",
            height: "40%"
          },
          {
            left: this.clientWidth_() > this.w? 120: 5,
            right: this.clientWidth_() > this.w? 50: 5,
            top:  this.clientWidth_() > this.w? "60%": "55%",
            height: "45%"
          }
        ],
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            axisLine: { onZero: true },
            data: this.chartData("start_time")
          },
          {
            gridIndex: 1,
            type: "category",
            boundaryGap: false,
            axisLine: { onZero: true },
            data: this.chartData("start_time"),
            position: "top"
          }
        ],
        yAxis: [
          {
            name: "硬度( g )",
            type: "value",
            max: 550
          },
          {
            gridIndex: 1,
            max: 550,
            name: "",
            type: "value"
            // inverse: true // 开始方向
          }
        ],
        series: [
          {
            name: "折线图统计",
            type: "line",
            symbolSize: 8,
            hoverAnimation: false,
            data: this.chartData("strength"),
            itemStyle: {
              normal: {
                color: "#c23531"
              }
            },
            areaStyle: {
                color: new $echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                    offset: 0,
                    color: 'rgba(176, 32, 28, 1)'
                }, {
                    offset: 0.5,
                    color: 'rgba(176, 32, 28, 0.6 )'
                }, {
                    offset: 1,
                    color: 'rgba(255, 255, 255, 0.3)'
                }])
            },
          },
          {
            name: "柱状图统计",
            type: "bar",
            // barWidth: 10,
            xAxisIndex: 1,
            yAxisIndex: 1,
            symbolSize: 8,
            hoverAnimation: false,
            data: this.chartData("strength"),
            itemStyle: {
              normal: {
                color: "#54db57",
                barBorderRadius: 5
              }
            }
          }
        ],
        visualMap: [
          {
            show: false,
            min: 0,
            max: 550,
            inRange: {
              //定义 在选中范围中 的视觉元素
              // color: ['rgba(0,255,255,0.7)', 'rgba(0,255,255,0.8)', 'rgba(0,255,255,0.9)', 'rgba(0,255,255,1)'],
              // symbolSize: [100, 200]
            }
          },
          {
            seriesIndex: 1,
            show: true,
            type: "piecewise",
            min: 50,
            max: 550,
            inRange: {
              //定义 在选中范围中 的视觉元素
              color: ["#ff9649", "#d8bd28", "#3885e3", "#43af46", "#c23531"]
              // symbolSize: [100, 0]
            },
            bottom: 65,
            pieces: [
              { min: this.erection.E, label: "超人" },
              { min: this.erection.D, max: this.erection.E, label: "正常" },
              { min: this.erection.C, max: this.erection.D, label: "不充分" },
              { min: this.erection.B, max: this.erection.C, label: "无效" },
              { min: this.erection.A, max: this.erection.B, label: "未勃起" }
            ]
          }
        ]
      });
    }
  }
};
</script>

<style lang="scss" scoped>

@media (min-width: 320px) and (max-width: 480px) {
  
  //CSS
  .v-subheader{
    display: inline-table;
  }
}

.root_p {
  font-size: 16px;
}
.v-divider.theme--light {
  margin-bottom: 20px;
}
#myChart__ {
  padding-top: 50px;
  display: inline-block;
}
#myChart___{
  display: inline-block;
  position: inherit;
}
#kkk{
 padding-top: 40px;
  
}

// #kkk{
//   width: 300px;
//   position: absolute;
//   bottom: 40%;
// }
// #kkk > div{
//   display: grid;
// }
</style>
